import { TemplateRef } from "@angular/core";
import * as moment from 'moment';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { GLOBAL } from 'src/app/services/global';
var AntecedentesComponent = /** @class */ (function () {
    function AntecedentesComponent(fb, dialog) {
        this.fb = fb;
        this.dialog = dialog;
        this.acotado = GLOBAL.acotado;
        this.rows = [];
        this.docs = [];
        this.tipo_permiso = new FormControl('', [Validators.required]);
        this.documentoNombre = '';
        this.maxDate = moment().toDate();
        if (!JSON.parse(localStorage.getItem("antecedentes"))) {
            localStorage.setItem("antecedentes", JSON.stringify(this.rows));
        }
        else {
            this.rows = JSON.parse(localStorage.getItem("antecedentes"));
        }
        if (this.acotado == true) {
            if (!JSON.parse(localStorage.getItem("ante"))) {
                localStorage.setItem("ante", JSON.stringify(this.rows));
            }
            else {
                this.rows = JSON.parse(localStorage.getItem("ante"));
            }
        }
        this.antecedente = { tipo_permiso: '', permiso: '', numero: 0, fecha: null, superficie: 0 };
        this.temp_ant = { tipo_permiso: '', permiso: '', numero: 0, fecha: null, superficie: 0 };
        this.form = new FormGroup({
            tipo_permiso: new FormControl(''),
            permiso: new FormControl(''),
            numero: new FormControl('', [Validators.min(0), Validators.pattern(/[0-9]*/)]),
            fecha: new FormControl({ value: '', disabled: true }),
            superficie: new FormControl('', [Validators.min(0), Validators.pattern(/[0-9]*/)])
        });
        // this.dialogform = new FormGroup({
        //     numero: new FormControl('', [Validators.min(0),Validators.pattern(/[0-9]*/)]),
        // })
        // this.form.controls['tipo_permiso'].setValue(this.rows[0] ? this.rows[0].tipo_permiso : '')
        // this.form.controls['permiso'].setValue(this.rows[0] ? this.rows[0].permiso : '')
        // this.form.controls['numero'].setValue(this.rows[0] ? this.rows[0].numero : '')
        // this.form.controls['fecha'].setValue(this.rows[0] ? new Date(this.rows[0].fecha) : null)
        // this.form.controls['superficie'].setValue(this.rows[0] ? this.rows[0].superficie : '')
    }
    AntecedentesComponent.prototype.add_docs = function () {
        this.dialog.open(this.openModalNODOC);
    };
    AntecedentesComponent.prototype.add = function () {
        console.log(this.documentoNombre);
        this.docs.push(this.documentoNombre);
        console.log(this.docs);
        /*   this.rows = JSON.parse(this.actualRow); */
        this.rows = this.rows.concat({
            nombre: this.documentoNombre,
        });
        console.log(this.rows);
        localStorage.setItem("ante", JSON.stringify(this.rows));
        this.documentoNombre = '';
    };
    AntecedentesComponent.prototype.delete_docs = function (id) {
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
            }
        }
        console.log(this.rows);
        localStorage.setItem("ante", JSON.stringify(this.rows));
    };
    AntecedentesComponent.prototype.add_antecedentes = function () {
        //si no tiene informacion...
        if (this.form.get('fecha').value) {
            this.fecha = moment(this.form.get('fecha').value).format('DD/MM/YYYY');
        }
        else {
            this.fecha = '';
        }
        this.actualRow = localStorage.getItem("antecedentes");
        this.rows = JSON.parse(this.actualRow);
        if (!this.form.value.tipo_permiso && !this.form.value.permiso && !this.form.value.numero && !this.form.value.fecha && !this.form.value.superficie) {
            console.log("no ingresó ningun campo");
            this.dialog.open(this.openModalNODATA);
        }
        else if (this.form.controls['numero'].hasError('pattern') || this.form.controls['superficie'].hasError('pattern')) {
            console.log("ingresó datos incorrectos");
            this.dialog.open(this.openModalNOVALID);
        }
        else {
            this.rows = this.rows.concat({
                tipo_permiso: this.form.value.tipo_permiso,
                permiso: this.form.value.permiso,
                numero: this.form.value.numero,
                fecha: this.fecha,
                superficie: this.form.value.superficie
            });
            localStorage.setItem("antecedentes", JSON.stringify(this.rows));
            this.form.reset();
        }
    };
    AntecedentesComponent.prototype.delete_antecedentes = function (id) {
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("antecedentes", JSON.stringify(this.rows));
            }
        }
        this.actualRow = localStorage.getItem("antecedentes");
        this.rows = JSON.parse(this.actualRow);
    };
    AntecedentesComponent.prototype.onChangeSelect = function (event) {
        var value = event.target.value;
        console.log(value);
    };
    AntecedentesComponent.prototype.get_antecedentes = function (id) {
        console.log(id);
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.temp_ant.numpermiso = id;
                this.temp_ant.tipo_permiso = this.rows[x].tipo_permiso;
                this.temp_ant.permiso = this.rows[x].permiso;
                this.temp_ant.numero = this.rows[x].numero;
                this.temp_ant.fecha = this.rows[x].fecha;
                this.temp_ant.superficie = this.rows[x].superficie;
                console.log(this.temp_ant);
                this.dialog.open(this.openModal);
            }
        }
    };
    AntecedentesComponent.prototype.cleanData = function () {
        this.temp_ant = { tipo_permiso: '', permiso: '', numero: 0, fecha: null, superficie: 0 };
    };
    AntecedentesComponent.prototype.saveAntecedentes = function () {
        var id = this.temp_ant.numpermiso;
        console.log(this.temp_ant);
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("antecedentes", JSON.stringify(this.rows));
                $("#antec_modal").modal("hide");
                this.actualRow = localStorage.getItem("antecedentes");
                this.rows = JSON.parse(this.actualRow);
                this.rows = this.rows.concat({
                    tipo_permiso: this.temp_ant.tipo_permiso,
                    permiso: this.temp_ant.permiso,
                    numero: this.temp_ant.numero,
                    fecha: this.temp_ant.fecha,
                    superficie: this.temp_ant.superficie
                });
                localStorage.setItem("antecedentes", JSON.stringify(this.rows));
                this.temp_ant.reset();
                this.dialog.closeAll();
            }
        }
    };
    return AntecedentesComponent;
}());
export { AntecedentesComponent };
